import React from 'react';
import { Tooltip,Image } from 'antd';
import '../index.css'


const AnalysisAnswer = (props) =>  {

    const {answer,analysisMeta,ti,svgIndex,setSvgIndex} = props
    const analysis_meta = analysisMeta
    const handleSvgNext = (list) => {
        let i = ti;
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        if (index[i] >= (svgList.length - 1)) {
            index[i] = 0
            setSvgIndex([...index])
            return svgList[0]
        }
        index[i] = index[i] + 1
        setSvgIndex([...index])
        return svgList[index[i]]
    }
    const handleSvgPrev = (list) => {
        let i = ti;
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        if (index[i] === 0) {
            index[i] = (svgList.length - 1)
            setSvgIndex([...index])
            return svgList[index[i]]
        }
        index[i] = index[i] - 1
        setSvgIndex([...index])
        return svgList[index[i]]
    }
    const getAnswerSvg = (list) => {
        let i = ti;
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        return svgList[index[i]]
    }
    console.log(answer)
    return (
        <div>
            <div className={'answerFx'}>
                <div>
                    <Tooltip placement="bottom" title={'展开'}>
                        <Image
                            onClick={() => handleSvgNext(answer?.responder_content[0].content.gbw_of_sentences[0])}
                            alt={'下一张'}
                            src={require('../../../../assets/comm/ai-chat-big.png')}
                            width={20} preview={false}></Image>
                    </Tooltip>
                </div>
                <div>
                    <Tooltip placement="bottom" title={'收起'}>
                        <Image
                        onClick={() => handleSvgPrev(answer?.responder_content[0].content.gbw_of_sentences[0])}
                        alt={'上一张'}
                        src={require('../../../../assets/comm/ai-chat-small.png')}
                        width={20} preview={false}></Image>
                    </Tooltip>
                </div>
            </div>
            <div className="answerSvg"
                 dangerouslySetInnerHTML={{__html: getAnswerSvg(answer?.responder_content[0].content.gbw_of_sentences[0])}}/>
        </div>
    );
}


export default AnalysisAnswer

